import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { isDemo } from './isDemo';
import { AGENT_EMAIL, DEMO_SERIAL, resetStore } from './store';

export default function DemoBanner() {
  const [searchParams] = useSearchParams();
  const enabled = isDemo();
  const scenario = searchParams.get('demo');

  useEffect(() => {
    if (!enabled || !scenario) {
      return;
    }
    resetStore(scenario);
  }, [enabled, scenario]);

  if (!enabled) {
    return null;
  }

  return (
    <div className="bg-amber-400 text-black text-xs px-3 py-2 text-center z-50">
      Demo mode (local only). Any email/password signs in.
      Agent: {AGENT_EMAIL}. Device: {DEMO_SERIAL}.
      {' '}
      Scenarios: <code>?demo=empty</code>, <code>?demo=active</code>, <code>?demo=duplicate</code>.
    </div>
  );
}
